const CONTRACT_TYPE = [
    { value: "Verbal", label: "Verbal" },
    { value: "ThroughRealEstateAgency", label: "Através de imobiliária" },
    { value: "DirectWithOwner", label: "Direto com o proprietário" },
];

export default CONTRACT_TYPE